import './CennikPage.css'
import { CgCopyright } from 'react-icons/cg';

interface PriceItem {
    service: string;
    price: string;
}

function CennikPage() {
    const priceList: PriceItem[] = [
        { service: 'Potvrdenie o zdravotnej spôsobilosti pre vodičský preukaz', price: '10 €' },
        { service: 'Potvrdene pre účely cestovania do zahraničia aj v angličtine', price: '10 €' },
        { service: 'Potvrdenie o diabetickej diéte pre zamestnávateľa', price: '10 €' },
        { service: 'Potvrdenie na výkon práce pre zamestnávateľa', price: '10 €' },
        { service: 'Vyjadrenie o zdravotnom stave pre príslušné orgány', price: '20 €' },
        { service: 'Konzultácia nedispenzarizovaných pacientov s lekárom', price: '20 €' },
        { service: 'Vstupné obezitologické vyšetrenie', price: '40 €' },
        { service: 'Kontrolné obezitologické vyšetrenie', price: '20 €' },
        { service: 'Vyšetrenie krvi na ambulancii prístrojom PoC - na počkanie (glykémia, glykovaný hemoglobín)', price: '10 €' },
        { service: 'Administratíva navyše', price: '5 €' },
        { service: 'Infúzne sety (10 ks)', price: '10 €' },
        { service: 'Vyšetrenie biothesiometrom dolných končatín (Dôvera)', price: '10 €' },
    ];

    return (
        <div className='contentContainer cennikPage'>
            <div className='cennikWrapper'>
                <div className='cennikHeader'>
                    <h1 className='cennikTitle'>Cenník výkonov</h1>
                    <div className='cennikSubtitle'>
                        <p className='cennikLocation'>Diabetologická ambulancia</p>
                        <p className='cennikAddress'>Poliklinika Corrib, Levočská 26B, 05801, Poprad</p>
                        <p className='cennikValidity'>Platnosť od 1.1.2026</p>
                    </div>
                </div>

                <div className='priceListContainer'>
                    {priceList.map((item, index) => (
                        <div key={index} className='priceItem'>
                            <div className='priceItemContent'>
                                <div className='priceService'>{item.service}</div>
                                <div className='priceAmount'>{item.price}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='footer'>
                <CgCopyright/> All rights reserved DENTAVIA s.r.o.
            </div>
        </div>
    );
}

export default CennikPage;
